import React from 'react';
import PropTypes from 'prop-types';
import FSFlatButton from '../../../../../../src/components/lib/FSFlatButton';

const ExportsButtonWrapper = props => (
  <section className='generate-new-export'>
    <div className='prompt'>
      {props.prompt}
    </div>
    <div className='button-wrapper'>
      <FSFlatButton
        label={props.buttonLabel}
        onClick={props.buttonCallback}
        style={{
          float: 'right',
          width: '100%',
        }}
      />
    </div>
  </section>
);

ExportsButtonWrapper.propTypes = {
  buttonCallback: PropTypes.func,
  buttonLabel: PropTypes.string, // New Export
  prompt: PropTypes.string, // ready to generate a new data export?
};

export default ExportsButtonWrapper;



// WEBPACK FOOTER //
// ./modules/DataExports/components/home/children/children/exportsButtonWrapper.js